import type { QueryClient } from "@tanstack/react-query";
import {
  PENDING_ENROLLMENTS_REVIEW_WIDGET_KEYS,
  parsePendingEnrollmentsReviewFromWidgetData,
} from "@/lib/dashboard/pending-enrollments-review";
import { fetchWidgetDataBatched } from "@/lib/dashboard/widgets-client";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils/api/api-client";
import { resolveEffectiveTenantNumber } from "@/lib/utils/env/effective-tenant";
import { ClassEnrollmentsApi } from "@/openapi/generated";

export async function prefetchPendingEnrollmentsReview(
  queryClient: QueryClient,
  accessToken: string,
  highlightEnrollmentId?: number | null,
) {
  const tenantId = resolveEffectiveTenantNumber();

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.WidgetData, tenantId, "pending-enrollments-review"],
    queryFn: async () => {
      const items = await fetchWidgetDataBatched(accessToken, tenantId, [
        ...PENDING_ENROLLMENTS_REVIEW_WIDGET_KEYS,
      ]);
      return parsePendingEnrollmentsReviewFromWidgetData(items);
    },
    staleTime: 0,
  });

  if (highlightEnrollmentId != null && highlightEnrollmentId > 0) {
    await queryClient.prefetchQuery({
      queryKey: [
        QueryKeys.ClassesEnrollmentsByStudentId,
        "by-id",
        highlightEnrollmentId,
      ],
      queryFn: async () => {
        const service = createAuthenticatedApi(
          ClassEnrollmentsApi,
          accessToken,
        );
        try {
          return await service.getEnrollmentById({
            id: highlightEnrollmentId,
            xTenantID: tenantId,
          });
        } catch {
          return null;
        }
      },
      staleTime: 0,
    });
  }

  return queryClient;
}
